import { render, staticRenderFns } from "./ContactProfileAutomationButton.vue?vue&type=template&id=8d1b3e34&scoped=true"
import script from "./ContactProfileAutomationButton.vue?vue&type=script&lang=js"
export * from "./ContactProfileAutomationButton.vue?vue&type=script&lang=js"
import style0 from "./ContactProfileAutomationButton.vue?vue&type=style&index=0&id=8d1b3e34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1b3e34",
  null
  
)

export default component.exports